import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEStdCapBarController from '../../bars/cap/std/oe-std-cap-bar-controller';
import {OEXRayIcarusCustomPropKey, OEXRayIcarusTargetType, OEXRayIcarusMode, OEXRayIcarusId, OEXRayIcarusModel} from './oe-xray-icarus-model';

export class OEXRayIcarusCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.connectFlag = false;

        this.model = OEXRayIcarusModel.shared();
        if(!this.model.data) this.model.setData(OEXRayIcarusModel.stdData());

        this.mode = OEXRayIcarusMode.uninitialized;
        this.id = new OEXRayIcarusId();

        this.targetTypes = [
            {id: OEXRayIcarusTargetType.patient, target: this.model.getTarget(), label: 'Positioning', labelId: 'cap_bar_target_title_positioning'},
            {id: OEXRayIcarusTargetType.xRay, target: this.model.getTarget(), label: 'X-Ray', labelId: 'cap_bar_target_title_xray', disabledTooltipId: 'cap_bar_disabled_target_type_tooltip'},
            {id: OEXRayIcarusTargetType.anatomy, label: '3D-Anatomy', labelId: 'cap_bar_target_title_anatomy', disabledTooltipId: 'cap_bar_disabled_target_type_tooltip'},
            {id: OETarget.effigosExplorerHelp, target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        ];

        this.onCustomPropertyChanged = this.onCustomPropertyChanged.bind(this);

        this.onControllerRef = this.onControllerRef.bind(this);

        this.targetTypeForTarget = this.targetTypeForTarget.bind(this);
        this.isTargetTypeDisabled = this.isTargetTypeDisabled.bind(this);
        this.onTargetBtnPressed = this.onTargetBtnPressed.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.customPropertyChanged, this.onCustomPropertyChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.customPropertyChanged, this.onCustomPropertyChanged);
    }

    updateActiveTargetType()  {
        if(this.controllerRef)    this.controllerRef.updateActiveTargetType();
    }

    updateTargetTypesEnabledState() {
        if(this.controllerRef)    this.controllerRef.updateTargetTypesEnabledState();
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.connectFlag = false;
            this.updateTargetTypesEnabledState();
            return;
        }

        if(this.props.target === this.model.getTarget())    {
            const si = this.oe.sharedInterface;

            //
            if(this.lastConnectedTarget && this.lastConnectedTarget !== this.props.target && (this.mode == OEXRayIcarusMode.xRay || !this.model.isIdleOrNull(this.id)) && this.controllerRef)  {
                let anatomyTarget = this.controllerRef.getLastTargetForType(OEXRayIcarusTargetType.anatomy);
                let id_ = this.model.getItemForTarget(anatomyTarget, this.id);
                if(id_) this.id = id_;
            }

            // disable camera animation for initial setup
            si.setCustomBoolProperty(OEXRayIcarusCustomPropKey.animateCamera, false);

            //
            let id = si.getCustomProperty(OEXRayIcarusCustomPropKey.itemId);
            id = new OEXRayIcarusId(id.value);
            if(!this.model.isNull(this.id) && !OEXRayIcarusId.isEqual(id, this.id))    {
                let index = si.getUIControllerAnimation().getAnimationIndex(this.model.hasSub(this.id) ? this.id.sub : this.id.item);
                si.getUIControllerAnimation().setActiveAnimation(index);
                si.getUIControllerMediaCenter().setActualMediaItemResourceID(this.model.hasSub(this.id) ? this.id.sub : this.id.item);
            }

            let mode = si.getCustomProperty(OEXRayIcarusCustomPropKey.mode).value;
            if(this.mode != OEXRayIcarusMode.uninitialized && mode !== this.mode)  {
                si.setCustomIntProperty(OEXRayIcarusCustomPropKey.mode, this.mode);
            }

            si.setCustomBoolProperty(OEXRayIcarusCustomPropKey.animateCamera, true);

            this.mode = si.getCustomProperty(OEXRayIcarusCustomPropKey.mode).value;
            id = si.getCustomProperty(OEXRayIcarusCustomPropKey.itemId);
            this.id = new OEXRayIcarusId(id.value);
        }

        this.lastConnectedTarget = this.props.target;

        this.connectFlag = true;

        this.updateActiveTargetType();
        this.updateTargetTypesEnabledState();
    }

    onCustomPropertyChanged(message, userInfo)  {
        if(!this.connectFlag || this.props.target !== this.model.getTarget())   return;
        if(userInfo.key === OEXRayIcarusCustomPropKey.mode || userInfo.key === OEXRayIcarusCustomPropKey.itemId)   {
            const si = this.oe.sharedInterface;
            this.mode = si.getCustomProperty(OEXRayIcarusCustomPropKey.mode).value;
            let id = si.getCustomProperty(OEXRayIcarusCustomPropKey.itemId);
            this.id = new OEXRayIcarusId(id.value);
            this.updateActiveTargetType();
            this.updateTargetTypesEnabledState();
        }
    }

    onControllerRef(ref)   {
        this.controllerRef = ref;
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEStdCapBarController
                    {...this.props}
                    className="xray-icarus-cap-bar"
                    targetTypes={this.targetTypes}
                    targetTypeForTarget={this.targetTypeForTarget}
                    isTargetTypeDisabled={this.isTargetTypeDisabled}
                    onTargetBtnPressed={this.onTargetBtnPressed}
                    ref={this.onControllerRef}
                />
            </React.Fragment>
        );
    }

    targetTypeForTarget(target) {
        if(this.model.getTarget() === target)   {
            return this.mode === OEXRayIcarusMode.xRay ? OEXRayIcarusTargetType.xRay : OEXRayIcarusTargetType.patient;
        } else {
            return target != OETarget.effigosExplorerHelp ? OEXRayIcarusTargetType.anatomy : OETarget.effigosExplorerHelp;
        }
    }

    suitableAnatomyTarget() {
        let target = this.model.getItemTarget(this.id);

        if(this.model.isIdleOrNull(this.id) && this.controllerRef)   {
            let lastAnatomyTarget = this.controllerRef.getLastTargetForType(OEXRayIcarusTargetType.anatomy);
            if(lastAnatomyTarget)   target = lastAnatomyTarget;
        }

        return target;
    }

    isTargetTypeDisabled(targetTypeId, sender)    {
        if(!this.connectFlag)   return true;
        
        if(targetTypeId === OEXRayIcarusTargetType.anatomy && !this.suitableAnatomyTarget())    return true;

        if(targetTypeId === OEXRayIcarusTargetType.xRay && this.model.isIdleOrNull(this.id))    return true;

        if(sender.activeTargetType !== OEXRayIcarusTargetType.patient || !this.model.isIdleOrNull(this.id))   return false;
        
        return targetTypeId !== OEXRayIcarusTargetType.patient;
    }

    onTargetBtnPressed(targetType, target, sender)  {
        if(targetType.id == OEXRayIcarusTargetType.anatomy)  {
            let target = this.suitableAnatomyTarget();
            this.props.appComponent.app.changeTarget(target);
        } else if(targetType.id == OEXRayIcarusTargetType.patient || targetType.id == OEXRayIcarusTargetType.xRay)  {
            let mode = targetType.id == OEXRayIcarusTargetType.patient ? OEXRayIcarusMode.std : OEXRayIcarusMode.xRay;

            if(sender.activeTargetType == OEXRayIcarusTargetType.anatomy || sender.activeTargetType == OETarget.effigosExplorerHelp)  {
                this.mode = mode;
                this.props.appComponent.app.changeTarget(this.model.getTarget());
            } else {
                this.oe.sharedInterface.setCustomIntProperty(OEXRayIcarusCustomPropKey.mode, mode);
            }
        }
    }
}

OEXRayIcarusCapBar.defaultProps = {
    moduleId: ''
};

OEXRayIcarusCapBar.propTypes = {
    moduleId: PropTypes.string
};

export default connectAppEnv((env) => { return {
    target: env.config.target,
    appComponent: env.component
}})(OEXRayIcarusCapBar);